import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const UploadVideo = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        url: '',
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subjectMasterId: '',
        subTopicMasterId: ''
    }

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [showPdfLink, setShowPdfLink] = useState("")

    const [isFullScreen, setFullScreen] = useState(false);
    const playerRef = useRef(null);
    const [played, setPlayed] = useState(0);
    const [play, setPlay] = useState(false)
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNewVideo, setAddNewVideo] = useState(false);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subTopicNameSort, setSubTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["syllabusStructureMasterDetails.syllabusStructureName", "subjectMasterDetails.subjectName", "lessonMasterDetails.lessonName", "topicMasterDetails.topicName", "subTopicMasterDetails.subTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        if (subtopicData.subjectMasterId !== '' && subtopicData.syllabusStructureMasterId !== '') {
            // Construct the API URL when syllabusData changes
            let apiUrl = '/get-text-book-upload-video?';

            if (subtopicData.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${subtopicData.syllabusStructureMasterId}&`;
            }

            if (subtopicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`
            }

            if (subtopicData.lessonMasterId) {
                apiUrl += `lessonMasterId=${subtopicData.lessonMasterId}&`;
            }

            if (subtopicData.topicMasterId) {
                apiUrl += `topicMasterId=${subtopicData.topicMasterId}&`;
            }

            if (subtopicData.subTopicMasterId) {
                apiUrl += `subTopicMasterId=${subtopicData.subTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.subjectMasterId !== '' && subtopicData.syllabusStructureMasterId !== '') {
                setSubtopicList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (subtopicData.subjectMasterId !== '' && subtopicData.syllabusStructureMasterId !== '') {

            // apiUrl = apiUrl.replace(/&$/, '');
            let apiUrl = getApiUrl();
            // Make the API call
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result);
                })
                .catch(error => {
                    setSubtopicList([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error fetching data: ", errorMsg)
                });
        }
    }, [subtopicData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewVideo])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList?.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Fetch error data: ", errorMsg)
            });
    }

    const getVideoList = () => {
        if (subtopicData.subjectMasterId !== '' && subtopicData.syllabusStructureMasterId !== '') {
            // const apiUrl = `/get-text-book-upload-video`;
            let apiUrl = getApiUrl();
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result)
                    setAddNewVideo(!addNewVideo)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error fetching data: ", errorMsg)
                });
        }
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subjectMasterId: '',
                subTopicMasterId: ''
            }
        })

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
                setSubtopicList([]);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error fetching data: ", errorMsg)
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicMasterId: ''
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${subtopicData.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;

        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', error);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: '',
                subTopicMasterId: ''
            }
        })
        const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', error);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subTopicMasterId: ''
            }
        })
        const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${subtopicData.syllabusStructureMasterId}&subjectMasterId=${subtopicData.subjectMasterId}&lessonId=${subtopicData.lessonMasterId}&topicId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const isValidUrl = (url) => {
        // Regular expression to match URL format
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
        // Test the given URL against the regex pattern
        return urlRegex.test(url);
    };

    //error

    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        // Check if every error is an empty string
        const errorsValid = Object.values(error).every(error => error === '');

        // Check if every value in subtopicData is either a non-empty string or undefined
        const subtopicDataValid = Object.entries(subtopicData).every(([key, value]) => {
            // Exclude topicMasterId and subTopicMasterId from validation
            if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '' && key !== 'url') { // Skip validation for URL if it's empty
                        return false;
                    } else if (key === 'url' && value !== '' && !isValidUrl(value)) { // Validate URL
                        return false;
                    }
                }
            }
            return true;
        });

        return errorsValid && subtopicDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                // Exclude topicMasterId and subTopicMasterId from validation
                if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
                    if (value === '' || value.length === 0 || (key === 'url' && !isValidUrl(value))) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: value === '' ? 'This field is required.' : 'Invalid URL'
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: ''
                        }));
                    }
                }
            }
        }
    }, [subtopicData]);

    const addVideo = () => {
        const apiUrl = `/add-text-book-upload-video`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, subtopicData)
                .then(response => {
                    getVideoList();
                    setSubtopicData(prevData => ({
                        ...prevData,
                        subTopicName: '',
                        url: '',
                    }));
                    setSaveId(response.data.result.id);
                    setSyllabusStructureNameSort(null);
                    setSubjectSort(null);
                    setLessonNameSort(null);
                    setTopicNameSort(null);
                    setSubTopicNameSort(null);
                    Swal.fire({ text: response.data.message });
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({ text: errorMsg });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
                    if (value === '' || value.length === 0) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: 'This field is required.',
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: '',
                        }));
                    }
                }
            }

            // Check if URL is invalid
            if (!isValidUrl(subtopicData.url)) {
                setError(prevData => ({
                    ...prevData,
                    url: 'Invalid URL',
                }));
            }
        }
    };

    const reset = () => {
        setSubtopicData(initialFormState);
        setSubtopicList([]);
        setEditId('');
        setSyllabusStructureNameSort(null);
        setSubjectSort(null);
        setLessonNameSort(null);
        setTopicNameSort(null);
        setSubTopicNameSort(null);
    }

    const deleteSubtopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-text-book-upload-video?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSubtopic = () => {
        setLoading(true);
        const apiUrl = `/edit-sub-topic-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, subtopicData)
            .then(response => {
                getVideoList();
                setEditId(null);
                setSaveId(response.data.result.id);
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        subTopicName: '',
                        details: ''
                    }
                })

                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const [visible, setVisible] = useState(false)

    const DecodedHTMLComponent = ({ data }) => {
        const decodedData = atob(data);
        const decodedHTML = { __html: decodedData };

        return (
            <div className="instruction_box" dangerouslySetInnerHTML={decodedHTML} />
        );
    };

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setSubTopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subTopicNameSort == true || subTopicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [subTopicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload Video</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i> Upload Video</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusStructureMasterId && <p style={{ color: 'red' }}>{error.syllabusStructureMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={subtopicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={subtopicData.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.lessonMasterId && <p style={{ color: 'red' }}>{error.lessonMasterId}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleTopicChange} value={subtopicData.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.topicName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subTopicMasterId' onChange={handleInputChange} value={subtopicData.subTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.subTopicName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="url" value={subtopicData.url} onChange={handleInputChange} />
                                                    {error.url && <p style={{ color: 'red' }}>{error.url}</p>}
                                                </div>
                                            </div>



                                            <CModal
                                                backdrop="static"
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                                className={isFullScreen ? "full_scr_view" : ""}
                                            >
                                                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                                                <div className="test test-player">
                                                    <ReactPlayer
                                                        ref={playerRef}
                                                        url={showPdfLink}
                                                        playing={play}
                                                        volume={volume}
                                                        onProgress={handleProgress}
                                                        playbackRate={playbackRate}
                                                    >
                                                    </ReactPlayer>
                                                    <div className="overlay-layer">
                                                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                                                    </div>
                                                </div>
                                                <div className="video_content_bottom">
                                                    <div className="video_progress">
                                                        <input
                                                            type="range"
                                                            min={0}
                                                            max={1}
                                                            step="any"
                                                            value={played}
                                                            onChange={handleSeekChange}
                                                            className="input_slider"
                                                        />
                                                    </div>


                                                    <div className='play_pause_sound'>
                                                        <div className='sound'>
                                                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                                                            {volume >= 0.5 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-high"></i>
                                                            </button>}
                                                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-low"></i>
                                                            </button>}
                                                            {volume == 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-xmark"></i>
                                                            </button>}

                                                            <div className='sound_bar'>
                                                                <input
                                                                    type="range"
                                                                    value={volume}
                                                                    onChange={handleVolumeChange}
                                                                    min="0"
                                                                    max="1"
                                                                    step="0.01"
                                                                    className="input_slider"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='playbeack_speed'>
                                                            <span>Playback speed</span>
                                                            <select onClick={handleSpeedChange}>
                                                                <option value={0.25}>0.25</option>
                                                                <option value={0.5}>0.5</option>
                                                                <option value={0.75}>0.75</option>
                                                                <option selected value={1}>Normal</option>
                                                                <option value={1.25}>1.25</option>
                                                                <option value={1.5}>1.5</option>
                                                                <option value={1.75}>1.75</option>
                                                            </select>
                                                        </div>
                                                        {/* <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}> {isFullScreen ? <i class="fa fa-expand"></i> : <i class="fa fa-compress"></i>}</button>
                                                        </div> */}
                                                        <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                                                        </div>

                                                    </div>

                                                    {/* <button onClick={handleFullScreenToggle}>
                                                        {isFullScreen ? 'Exit Fullscreen' : 'Fullscreen'}
                                                    </button> */}
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addVideo}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>


                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"syllabusStructureMasterDetails.syllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"lessonMasterDetails.lessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"topicMasterDetails.topicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subTopicNameSort} setSortState={setSubTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subTopicMasterDetails.subTopicName"} />
                                                                        </th>
                                                                        <th scope='col'>Video</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.syllabusStructureMasterDetails?.syllabusStructureName}</td>
                                                                                        <td>{subtopic?.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.lessonMasterDetails?.lessonName}</td>
                                                                                        <td>{subtopic?.topicMasterDetails?.topicName}</td>
                                                                                        <td>{subtopic?.subTopicMasterDetails?.subTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(subtopic?.url)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteSubtopic(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Video Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UploadVideo;